import { Form } from 'antd';

import Input from '@/components/Inputs/Input';

export const CafeNameField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <Form.Item
      label="Cafe name"
      required={required}
      name="cafe_name"
      rules={
        required ? [{ required: true, message: 'Cafe name is required' }] : []
      }
    >
      <Input placeholder="Fill Cafe name" sizeType="m" />
    </Form.Item>
  );
};
